import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, withRouter, Redirect } from 'react-router-dom'
import { routes } from '../../../constantes/routes'
import PlusBtn from '../../buttons/PlusBtn'
import FinalProductsTable from './FinalProductsTable'
import FolderProductsTable from './FolderProductsTable'
import Search from '../../common/Search'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../../utils/swalAlert'
import { swalTitle } from '../../../constantes/swalTitle'
import Header from '../../header/Header'
import '../../../assests/styles/backoffice/articlesContainer.scss'
import _, { set } from 'lodash'
import {
  productsActions,
  familiesActions,
} from '../../../actions/articlesActions'
import { familiesTypes, productsTypes } from '../../../constantes/actionTypes'
import { swalMssgs } from '../../../constantes/swalMssgs'
import { downloadCSV } from '../../../utils/downloadCSV'
import { exportActions } from '../../../actions/exportActions'
import { entitiesExport } from '../../../constantes/exportEndpoints'

const ProductsContainer = () => {
  const history = useHistory()
  const userProfile = useSelector((state) => state.userProfile)

  const products = useSelector((state) => state.articles.products)
  const families = useSelector((state) => state.articles.families)

  const [loading, setLoading] = useState(false)
  const [showFinalProduct, setShowFinalProduct] = useState(true)

  const [itemsFinal, setItemsFinal] = useState([])
  const [itemsFolder, setItemsFolder] = useState([])

  const [search, setSearch] = useState('none')
  const [firstRender, setFirstRender] = useState(true)
  const [page, setPage] = useState(1)

  const dispatch = useDispatch()

  const getAllProducts = (search, page) =>
    dispatch(productsActions.getAllFinalProductsBySearch(search, page))
  const getAllFamilies = (search, page) =>
    dispatch(familiesActions.getAllFamiliesBySearch(search, page))
  const clearProducts = () => dispatch(productsActions.clearProductsList())
  const clearFamilies = () => dispatch(familiesActions.clearFamiliesList())

  const deleteProduct = (idProduct) =>
    dispatch(productsActions.deleteProduct(idProduct))
  const deleteFamily = (idFamily) =>
    dispatch(familiesActions.deleteFamily(idFamily))

  useEffect(() => {
    resetLists()
    window.addEventListener('scroll', _.throttle(handleScroll, 500))

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    setItemsFinal(products)
  }, [products])

  useEffect(() => {
    setItemsFolder(families)
  }, [families])

  useEffect(() => {
    if (page > 1) {
      if (showFinalProduct) {
        getAllProducts(search, page)
      } else {
        getAllFamilies(search, page)
      }
    }
  }, [page])

  useEffect(() => {
    if (!firstRender) {
      resetLists()
    } else {
      setFirstRender(false)
    }
  }, [showFinalProduct, search])

  //********************** Eliminar  producto final o carpeta
  const handleRemove = async (idArticle) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar el producto?',
      )

      if (alert.isConfirmed) {
        const response = showFinalProduct
          ? await deleteProduct(idArticle)
          : await deleteFamily(idArticle)

        if (
          response.type === familiesTypes.DELETE_FAMILY_SUCCESS ||
          response.type === productsTypes.DELETE_PRODUCT_SUCCESS
        ) {
          await swalSuccessGeneral(
            swalTitle.Eliminado,
            swalMssgs.DELETE_SUCCESS,
          )
        }
      }
    } catch (error) {
      try {
        swalAlertError(error.response.data || error.response.statusText)
      } catch(err) {
      }
      
    }
  }

  const handleScroll = () => {
    const documentHeight = document.body.scrollHeight
    const currentScroll = window.scrollY + window.innerHeight
    const modifier = 50

    if (currentScroll + modifier > documentHeight) {
      setPage((p) => p + 1)
    }
  }

  const resetLists = () => {
    clearProducts()
    clearFamilies()
    setPage(1)
    setItemsFinal([])
    setItemsFolder([])

    if (showFinalProduct) {
      getAllProducts(search, 1)
    } else {
      getAllFamilies(search, 1)
    }
  }

  //********************** Funcion auxiliar para el BUSCADOR
  const onChangeSearch = (value) => {
    const searchValue = value.trim() === '' ? 'none' : value.trim()
    setSearch(searchValue)
  }

  //Cambiar de vista, si se trata de producto final o familia/subfamilia
  const changeViewAndResetFilter = async (isShowFinalProdcut) => {
    setShowFinalProduct(isShowFinalProdcut)
  }

  const toBackoffice = () => {
    history.push(routes.BACKOFFICE)
  }

  const toNewArticle = () => {
    history.push(routes.PRODUCTS_NEW)
  }

  const toEditArticle = (id) => {
    history.push(routes.PRODUCTS_EDIT + id)
  }

  const handleExportCSV = async () => {
    const response = await dispatch(exportActions.exportCSV(entitiesExport.ARTICLES))
    downloadCSV("Articulos", response)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header
            text={'Gestionar productos'}
            route={toBackoffice}
            backBtn={true}
          />
          <div className='filter__wrap mb-80'>
            <Search onChangeSearch={onChangeSearch} placeholder={'Buscar...'} />
            <div className='add__action__rigth__side'>
              <div className='categories-products-btn'>
                <div>
                  <button
                    className='user-input btn-shape'
                    onClick={() => changeViewAndResetFilter(true)}
                  >
                    Productos
                  </button>
                </div>
                <div>
                  <button
                    className='user-input btn-shape'
                    onClick={() => changeViewAndResetFilter(false)}
                  >
                    famílias/subfamílias
                  </button>
                </div>
              </div>
              <button
                onClick={handleExportCSV}
                className='btn-landing'
                style={{ cursor: 'pointer', marginRight: '10px' }}
              >
                📊 Exportar CSV
              </button>
              <button className='action-button' onClick={toNewArticle}>
                <PlusBtn />
                <span>Añadir productos</span>
              </button>
            </div>
          </div>
          {showFinalProduct ? (
            <FinalProductsTable
              finalProducts={itemsFinal}
              toEditArticle={toEditArticle}
              handleRemove={handleRemove}
              userProfile={userProfile}
              loading={loading}
            />
          ) : (
            <FolderProductsTable
              foldersProducts={itemsFolder}
              toEditArticle={toEditArticle}
              handleRemove={handleRemove}
              userProfile={userProfile}
              loading={loading}
            />
          )}
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(ProductsContainer)
